import { render, staticRenderFns } from "./newFileDownloadIcon.vue?vue&type=template&id=0aa55fda&scoped=true"
import script from "./newFileDownloadIcon.vue?vue&type=script&lang=js"
export * from "./newFileDownloadIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa55fda",
  null
  
)

export default component.exports